import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchRejectedImportsOpportunities, appNotify, setImportLoadingOverlayState, revalidateImportRows, setImportDupCheckErrors,
  setImportOpportunityStatus, setImportName, setOpportunityImportSelectedChannel, setIsFromRejectedImports
} from 'store/actions';
import { getWithToken } from 'api/network';
import { Constants } from 'utilities/constants';
import { parseISO, format } from 'date-fns';

export function* getRejectedImportsSaga() {
  yield takeLatest(fetchRejectedImportsOpportunities, function* ({ payload }) {
    const importType = Constants.ImportType.OPPORTUNITIES
    const { id, callback } = payload;
    yield put(setImportLoadingOverlayState({ 
      importType,
      importLoadingOverlayState: {
        isLoading: true,
        message: `Fetching Opportunities for Rejected Import...`
      }
    }));

    try {
      const response = yield getWithToken(`/api/ThirdParty/import/rejected/${id}`);
      const res = yield response.json();
      console.log(res)
      yield put(setOpportunityImportSelectedChannel(res.channel)) // Set this first since validating import rows requires the channel
      yield put(revalidateImportRows({ // Use revalidateImportRowsSaga to validate rows, setImportRows, and reset import geo validation. Keep it out of the array of actions below- otherwise it won't trigger the saga
        importType,
        rows: res.rejectedImportItems.map(row => {
          const { id, ...rest } = row;
          return {
            ...rest,
            referenceId: id,
            contractCloseDate: formatDate(row.contractCloseDate),
            leaseEndDate: formatDate(row.leaseEndDate),
            mlsListingDate: formatDate(row.mlsListingDate),
            createdOn: formatDate(row.createdOn)
          }
        }),
        isFromRejectedImports: true
      }));
      if (res.requestedOpportunityStatus) {
        yield put(setImportOpportunityStatus({
          importType,
          importOpportunityStatus: res.requestedOpportunityStatus
        }));
      }
      yield put(setImportName({
        importType,
        importName: res.name
      }));
      yield put([
        setImportLoadingOverlayState({
          importType,
          importLoadingOverlayState: {
            isLoading: false,
            message: null 
          }
        }),
        setImportDupCheckErrors({ // Also reset any dup check errors
          importType,
          dupCheckErrors: []
        }),
        setIsFromRejectedImports({
          importType,
          isFromRejectedImports: true
        })
      ]);
      callback && callback();
    } catch (error) {
      yield put(setImportLoadingOverlayState({
        importType,
        importLoadingOverlayState: {
          isLoading: false,
          message: null
        }
      }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}

function formatDate(date) {
  if (date == null) return date;
  return format(parseISO(date), 'M/d/yyyy');
}